export var TrustSettlorNotApplicableReason;
(function (TrustSettlorNotApplicableReason) {
    TrustSettlorNotApplicableReason["Deceased"] = "DECEASED";
    TrustSettlorNotApplicableReason["MinorContribution"] = "MINOR_CONTRIBUTION";
})(TrustSettlorNotApplicableReason || (TrustSettlorNotApplicableReason = {}));
//# sourceMappingURL=TrustSettlorNotApplicableReason.js.map